import { FC } from "react";
import { useParams } from "react-router-dom";

import { TrainingCourse } from "@/features/training/pages/training-tab/panel-right/training-course/TrainingCourse";
import { CourseSession } from "@/features/training/pages/training-tab/panel-right/training-session/CourseSession";
import { UpcomingSessions } from "@/features/training/ui";
import { Box } from "@mui/material";

export const CoursePanelRight: FC = () => {
	const { courseId } = useParams();
	const { sessionId } = useParams();

	const content =
		sessionId !== undefined && courseId !== undefined ? (
			<CourseSession
				sessionId={parseInt(sessionId)}
				courseId={parseInt(courseId)}
			/>
		) : courseId !== undefined ? (
			<TrainingCourse courseId={parseInt(courseId)} />
		) : (
			<UpcomingSessions type={"course"} />
		);

	return (
		<Box
			data-tour="training-courses-right"
			sx={{
				flex: 1,
				minHeight: 0,
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
			}}
		>
			{content}
		</Box>
	);
};
